import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { DocumentsService } from "src/app/core/services/contributor-profile/documents.service";
import { UtilsService } from "src/app/core/services/utils.service";
import { IUploadedDocument } from "../documents.models";

@Component({
  selector: "app-generic-document",
  templateUrl: "./generic-document.component.html",
  styleUrls: ["./generic-document.component.scss"],
})
export class GenericDocumentComponent implements OnChanges {
  @Input() mandatoryDocumentItem;
  @Input() genericDocumentValue;
  @Input() isExhibition = false;
  @Input() enabledOnChangeEvent = false;
  @Input() isConsult = false;

  @Output() formValue: EventEmitter<any> = new EventEmitter();
  @Output() fileChange: EventEmitter<any> = new EventEmitter();
  @Output() downloadEvent: EventEmitter<IUploadedDocument> = new EventEmitter();

  documentFile: string;
  extension: string;
  sasUrl: string;
  utilsService: UtilsService;

  constructor(utilsService: UtilsService) {
    this.utilsService = utilsService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData(changes);
  }

  loadData(changes: SimpleChanges) {
    const data = changes.genericDocumentValue?.currentValue;

    if (data) {
      const { documentExtension } = data;
      this.extension = documentExtension;
    }

    if (data && data.documentFile) {
      this.sasUrl = data.documentFile;
    }
  }

  emitFormGenericDocumentValue() {
    if (!this.documentFile) {
      return;
    }

    const formGenericDocumentValue = this.createGenericDocumenyPayload();

    this.formValue.emit(formGenericDocumentValue);
  }

  getDocumentFile({ base64, extension }) {
    this.documentFile = base64;
    this.extension = extension;

    this.genericDocumentValue = this.createGenericDocumenyPayload();

    if (this.enabledOnChangeEvent)
      this.fileChange.emit(this.genericDocumentValue);
  }

  downloadFile() {
    const documentName = `${this.mandatoryDocumentItem.name}.${this.extension}`;

    if (this.sasUrl) {
      const uploadedFile: IUploadedDocument = {
        extension: this.extension,
        sasUrl: this.sasUrl,
        fileName: documentName,
      };
      this.downloadEvent.emit(uploadedFile);
    }
    if (this.documentFile && this.documentFile !== "null") {
      this.utilsService.downloadFile(this.documentFile, documentName);
    }
  }

  private createGenericDocumenyPayload() {
    return {
      documentFile: this.documentFile,
      documentId: this.mandatoryDocumentItem?.id,
      documentExtension: this.extension,
    };
  }
}
